export class InvHistoryModel {
    history_sequence: number;
    sup_sequence: number;
    invoice_no: number;
    pet_no: number;
    clinic: number;
    done_date: string;
    appr_date: string;
    inv_date: string;
    link_no: number;
    link_type: number;
    cost: number;
    unit: number;
    response1: string;
    response2: string;
    req_by: number;
    done_by: number;
    appr_by: number;
    inv_by: number;
    route: string;
    display: number;
    location: string;
    supervisor: number;

    constructor(
        history_sequence: number,
        sup_sequence: number,
        invoice_no: number,
        pet_no: number,
        clinic: number,
        done_date: string,
        appr_date: string,
        inv_date: string,
        link_no: number,
        link_type: number,
        cost: number,
        unit: number,
        response1: string,
        response2: string,
        req_by: number,
        done_by: number,
        appr_by: number,
        inv_by: number,
        route: string,
        display: number,
        location: string,
        supervisor: number
    ) {
        this.history_sequence = history_sequence;
        this.sup_sequence = sup_sequence;
        this.invoice_no = invoice_no;
        this.pet_no = pet_no;
        this.clinic = clinic;
        this.done_date = done_date;
        this.appr_date = appr_date;
        this.inv_date = inv_date;
        this.link_no = link_no;
        this.link_type = link_type;
        this.cost = cost;
        this.unit = unit;
        this.response1 = response1;
        this.response2 = response2;
        this.req_by = req_by;
        this.done_by = done_by;
        this.appr_by = appr_by;
        this.inv_by = inv_by;
        this.route = route;
        this.display = display;
        this.location = location;
        this.supervisor = supervisor;
    }
}
